import type React from 'react';

import * as styles from './styles';

import { ChevronIcon, ContentLoader } from '@cobliteam/base-components';

const Row = () => (
  <div className={styles.row}>
    <ContentLoader width={205} height={42}>
      <rect x='20' y='0' width='185' height='16' />
      <rect x='20' y='26' width='105' height='16' />
    </ContentLoader>
    <ContentLoader width={250} height={42}>
      <rect x='0' y='0' width='250' height='16' />
      <rect x='0' y='26' width='250' height='16' />
    </ContentLoader>
    <div>
      <ContentLoader width={94} height={42}>
        <rect x='0' y='13' width='64' height='16' />
      </ContentLoader>
      <ChevronIcon className={styles.icon} />
    </div>
  </div>
);

export const AccordionPlaceholder: React.FC<{}> = () => (
  <>
    <Row />
    <Row />
    <Row />
    <Row />
  </>
);
